'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_pages_AppPage$ExternalDocumentsList(pageCursor, kinds) {
  this.zb = null;
  this.BL = null;
  this.zb = pageCursor;
  this.BL = kinds;
}
export { $c_Lapp_pages_AppPage$ExternalDocumentsList as $c_Lapp_pages_AppPage$ExternalDocumentsList };
$p = $c_Lapp_pages_AppPage$ExternalDocumentsList.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_pages_AppPage$ExternalDocumentsList;
/** @constructor */
function $h_Lapp_pages_AppPage$ExternalDocumentsList() {
}
export { $h_Lapp_pages_AppPage$ExternalDocumentsList as $h_Lapp_pages_AppPage$ExternalDocumentsList };
$h_Lapp_pages_AppPage$ExternalDocumentsList.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_pages_AppPage$ExternalDocumentsList)) {
    var x = this.zb;
    var x$2 = x$0.zb;
    if (((x === null) ? (x$2 === null) : x.f(x$2))) {
      var x$3 = this.BL;
      var x$4 = x$0.BL;
      return ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 2;
});
$p.t = (function() {
  return "ExternalDocumentsList";
});
$p.e = (function(n) {
  if ((n === 0)) {
    return this.zb;
  }
  if ((n === 1)) {
    return this.BL;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.u = (function(n) {
  if ((n === 0)) {
    return "pageCursor";
  }
  if ((n === 1)) {
    return "kinds";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lapp_pages_AppPage$ExternalDocumentsList(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.kc)));
}
export { $isArrayOf_Lapp_pages_AppPage$ExternalDocumentsList as $isArrayOf_Lapp_pages_AppPage$ExternalDocumentsList };
var $d_Lapp_pages_AppPage$ExternalDocumentsList = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_pages_AppPage$ExternalDocumentsList, "app.pages.AppPage$ExternalDocumentsList", ({
  kc: 1,
  aB: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_pages_AppPage$ExternalDocumentsList as $d_Lapp_pages_AppPage$ExternalDocumentsList };
//# sourceMappingURL=app.pages.-App-Page$-External-Documents-List.js.map
